export default __webpack_public_path__ + "media/images/search_32-3615261287c93883bc46210115abe326.png";